function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("rect", {
  width: 159,
  height: 114,
  x: 0.5,
  y: 0.5,
  rx: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139.5,
  cy: 32.5,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139.5,
  cy: 67.5,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.5 28.883l-4.55 6.617h9.1l-4.55-6.617zm0 43.234l-4.55-6.617h9.1l-4.55 6.617z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 26.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 41.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 56.5,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 71.5,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 13.5h92v72h-92z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 11,
  x: 60.5,
  y: 94.5,
  rx: 5.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 11,
  x: 60.5,
  y: 94.5,
  rx: 5.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.89 66.516l-21.893-.056c11.075-9.203 20.486-17.673 20.486-25.109 0-5.615-4.884-7.851-8.992-7.851-4.42 0-7.8 1.924-9.567 4.68M55.875 67l15.286-33.467H51.453"
}));

function SvgRoomThermostatLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 115,
    viewBox: "0 0 160 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomThermostatLarge);
export default __webpack_public_path__ + "static/media/RoomThermostatLarge.f8dbe029.svg";
export { ForwardRef as ReactComponent };